import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React, { useEffect } from 'react';
import './index.scss';
import { BrowserRouter } from 'react-router-dom';
import ReactDOM from 'react-dom/client';

import './assets/css/bootstrap.min.css';
import './assets/css/style.css';

import { unregister } from './registerServiceWorker';

import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { ThemeProvider } from '@mui/material/styles';
import theme from './assets/customisedMUI/theme';
// import { PublicClientApplication } from '@azure/msal-browser';
// import { MsalProvider } from '@azure/msal-react';
// import { msalConfig } from 'config/msal';
import { GoogleOAuthProvider } from '@react-oauth/google';
import _ from 'lodash';

//redux
import { Provider } from 'react-redux';

import store from './store/';
import { PermissionProvider } from 'permissions/PermissionContext';
import { PostHogProvider, PostHogErrorBoundary } from 'posthog-js/react';
import * as Sentry from '@sentry/react';
import { ChunkRecoveryUrlRestorer, installChunkLoadRecovery } from './utils/chunkLoadRecovery';
import { normalizePath } from './utils/normalizePath';

//intercom
import { IntercomProvider } from 'react-use-intercom';
import { INTERCOM_APP_ID } from './constants';

// const msalInstance = new PublicClientApplication(msalConfig);
const clientId = '651065819092-t97i9tfuknprp3cl13cg2bgf6c3dapvn.apps.googleusercontent.com';
const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

// Property keys that may hold a personal/organisation name (teacher, student,
// school, class), an email, or a free-text/content title that could embed one.
// Any of these is deleted from every event + person profile before send so no
// names are ever tracked in PostHog. `button_name`, `report_type`, `login_method`
// etc. are intentionally NOT here — they are fixed labels, not names.
const PII_NAME_KEYS = [
    'name',
    'full_name',
    'fullName',
    'first_name',
    'firstName',
    'last_name',
    'lastName',
    'nickname',
    'email',
    'username',
    'user_name',
    'school_name',
    'schoolName',
    'class_name',
    'className',
    'student_name',
    'studentName',
    'teacher_name',
    'teacherName',
    'password',
];
const stripNames = (obj) => {
    if (obj && typeof obj === 'object') {
        PII_NAME_KEYS.forEach((key) => {
            if (key in obj) delete obj[key];
        });
    }
    return obj;
};

const isInIframe = () => {
    try {
        return window.self !== window.top;
    } catch (e) {
        // Accessing window.top across origins throws — which itself means we're framed.
        return true;
    }
};
const IN_IFRAME = isInIframe();

const options = {
    api_host: 'https://us.i.posthog.com',
    defaults: '2025-05-24',

    autocapture: false,
    capture_pageview: false,
    capture_pageleave: false,
    capture_pageview_performance: false,
    capture_exceptions: false,
    disable_session_recording: true,

    person_profiles: 'identified_only',

    before_send: (event) => {
        if (!event || !event.properties) return event;
        const properties = event.properties;

        let path = properties['$pathname'];
        if (!path && properties['$current_url']) {
            try {
                path = new URL(properties['$current_url']).pathname;
            } catch (e) {
                path = undefined;
            }
        }
        if (path) properties.route = normalizePath(path);

        // Tag every event with whether it fired inside a partner iframe.
        properties.in_iframe = IN_IFRAME;

        stripNames(properties);
        stripNames(properties['$set']);
        stripNames(properties['$set_once']);
        return event;
    },
};

const apiKey =
    window.location.hostname.includes('lifeskillsgo.com') && !window.location.hostname.includes('-staging')
        ? 'phc_SyrUqaYTzykPhL9SDiykmyJJ7j2c6HTZx2j53ioASEU'
        : window.location.hostname.includes('lifeskillsgo.com') && window.location.hostname.includes('-staging')
          ? 'phc_cXHYyd49ojjxP2detCb43tEwglRf2fjavzu3IN0IyYv'
          : '';

Sentry.init({
    dsn: 'https://30ee53d44690c98a7019a924b346eb31@o4509952834928640.ingest.us.sentry.io/4510258388926464',
    environment: window.location.hostname.includes('lifeskillsgo.com')
        ? window.location.hostname.includes('-staging')
            ? 'staging'
            : 'production'
        : 'development', // sets the environment
    sendDefaultPii: false, //info like user's ip address, user info etc is not sent to sentry
    sampleRate: 0.05, //how much of your app’s request traffic to sample for performance tracing. 0.2 = capture 20% of requests. Sentry randomly picks 1 out of 5 requests to record in detail.
});

installChunkLoadRecovery();

const app = (
    <Provider store={store}>
        <PostHogProvider apiKey={apiKey} options={options}>
            <BrowserRouter>
                <ChunkRecoveryUrlRestorer />
                <ThemeProvider theme={theme}>
                    <PostHogErrorBoundary fallback={<ErrorBoundary />}>
                        <ErrorBoundary>
                            <GoogleOAuthProvider clientId={clientId}>
                                {/* <MsalProvider instance={msalInstance}> */}
                                <PermissionProvider>
                                    <IntercomProvider appId={INTERCOM_APP_ID}>
                                        <App />
                                    </IntercomProvider>
                                </PermissionProvider>
                                {/* </MsalProvider> */}
                            </GoogleOAuthProvider>
                        </ErrorBoundary>
                    </PostHogErrorBoundary>
                </ThemeProvider>
            </BrowserRouter>
        </PostHogProvider>
    </Provider>
);

root.render(app);

window.lsgo = {};
window.lsgo.registerLsgoFunction = (key, fun) => _.set(window.lsgo, key, fun);

unregister();
